import { history } from "../../src/index";

import * as types from '../constants/templatedetails';
import * as toasterTypes from '../constants/ActionTypes';
import * as templatedetailsApi from '../api/templatedetails';

export function resetTemplate() {
    // console.log("resetCustomer action call");
    return dispatch => {
        dispatch({ type: types.FETCH_TEMPLATE_RESET });
    }
}

export function fetchTemplateList() {
    // console.log("fetchTeamDetails action call");
    return dispatch => {
        dispatch({ type: types.FETCH_TEMPLATE_LIST_REQUEST });
        templatedetailsApi.getTemplateList().then(function (response) {
                // console.log("fetchTeamDetails", response)
                dispatch({ type: types.FETCH_TEMPLATE_LIST_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {                
                dispatch({ type: types.FETCH_TEMPLATE_LIST_REQUEST_ERROR });
            });
    }
}

export function fetchTemplateDetailsById(id) {
// console.log("fetchTeamDetails by id action call");
    return dispatch => {
        dispatch({ type: types.FETCH_TEMPLATE_REQUEST });
        templatedetailsApi.fetchTemplateDetailsById(id).then(function (response) {
                // console.log("fetchTemplateDetails", response)
                dispatch({ type: types.FETCH_TEMPLATE_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {                
                dispatch({ type: types.FETCH_TEMPLATE_REQUEST_ERROR });
            });
    }
}

export function updateTemplateDetails(objModel) {
    // console.log("editTemplateDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.EDIT_TEMPLATE_REQUEST });
        templatedetailsApi.updateTemplateDetails(objModel)
            .then(function (response) {
                // console.log("addTeamDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.EDIT_TEMPLATE_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Saved Successfully" });
                }
                else
                    dispatch({ type: types.EDIT_TEMPLATE_REQUEST_ERROR });
                dispatch({ type: types.FETCH_TEMPLATE_RESET });
                history.push('/template/template-list');
            })
            .catch(function (err) {
                // console.log("addTeamDetails action err", err)
                dispatch({ type: toasterTypes.DISPLAY_ERROR, message: 'System Error' });
                dispatch({ type: types.EDIT_TEMPLATE_REQUEST_ERROR });
            });
    }
}




// WEBPACK FOOTER //
// ./actions/templatedetails.js